"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ic_chart__bar__dark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "1em",
    height: "1em",
    viewBox: "0 0 192 192"
  }, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("symbol", {
    id: "7330e33b-c963-4224-865d-986bd28124e5",
    "data-name": "Bar_chart_ic_hi",
    viewBox: "0 0 192 192"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 192,
    height: 192,
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 192,
    height: 192,
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 24,
    width: 144,
    height: 144,
    rx: 16,
    ry: 16,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152,166H40a16,16,0,0,1-16-16v2a16,16,0,0,0,16,16H152a16,16,0,0,0,16-16v-2A16,16,0,0,1,152,166Z",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74,127.89H58A1.89,1.89,0,0,1,56.11,126V90A1.89,1.89,0,0,1,58,88.11H74A1.89,1.89,0,0,1,75.89,90v36A1.89,1.89,0,0,1,74,127.89Z",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134,127.89H118a1.89,1.89,0,0,1-1.89-1.89V72A1.89,1.89,0,0,1,118,70.11h16A1.89,1.89,0,0,1,135.89,72v54A1.89,1.89,0,0,1,134,127.89Z",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74,127.89H58A1.89,1.89,0,0,1,56.11,126V90A1.89,1.89,0,0,1,58,88.11H74A1.89,1.89,0,0,1,75.89,90v36A1.89,1.89,0,0,1,74,127.89Z",
    opacity: 0.12
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134,127.89H118a1.89,1.89,0,0,1-1.89-1.89V72A1.89,1.89,0,0,1,118,70.11h16A1.89,1.89,0,0,1,135.89,72v54A1.89,1.89,0,0,1,134,127.89Z",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104,127.89H88A1.89,1.89,0,0,1,86.11,126V54A1.89,1.89,0,0,1,88,52.11h16A1.89,1.89,0,0,1,105.89,54v72A1.89,1.89,0,0,1,104,127.89Z",
    fill: "#e60000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142,140H50a2,2,0,0,1,0-4h92a2,2,0,0,1,0,4Z",
    fill: "#4a4d4e"
  }))), /*#__PURE__*/React.createElement("title", null, "chart-bar-hi-dark"), /*#__PURE__*/React.createElement("g", {
    id: "e58d761f-3ab7-4339-b4a2-8b29454453c8",
    "data-name": "Bar_chart_ic"
  }, /*#__PURE__*/React.createElement("use", {
    id: "4f3932f6-a40d-42b6-b5e6-d645c61e42f2",
    "data-name": "Bar_chart_ic_hi",
    width: 192,
    height: 192,
    xlinkHref: "#7330e33b-c963-4224-865d-986bd28124e5"
  })));
}

var _default = ic_chart__bar__dark;
exports.default = _default;